import {Component, OnInit} from '@angular/core';
import * as platform from 'platform';
import {RestService} from "../../services/rest.service";
import {dic} from "../../dictionary";
import {NotificationService} from "../../services/notification.service";
import {GeneralService} from "../../services/general.service";
import {HttpClient, HttpEventType, HttpHeaders, HttpRequest} from "@angular/common/http";
import {FileUploader} from "ng2-file-upload";
import {AuthService} from "../../services/auth.service";
import {ENV_CONSTS} from "../../constants";
import * as _ from 'lodash';
import util from "util";
import {TranslationService} from "../../services/translation.service";

@Component({
    selector: 'contact-us-component',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {

    dic = dic;
    createTicketInProcess = false;
    textMessage = '';
    messageTitle = '';
    ddsOS = false;
    dssRsn = false;

    OSTypes = ['Windows 11', 'Windows 10','Mac','Android','iOS', 'Linux'];
    OSSelectedType = 'Windows 11';

    reason = ["Question", "Incident", "Request", "Bug Report", "Problem", "False Negative / Positive", "Renewal", "Feature Request"];
    reasonSelected = 'Question';

    browsers: ['Chrome', 'Edge','Firefox','Safari','Opera'];
    browserSelected = 'Chrome';

    mouseOverAttachment = false;
    uploader:FileUploader = new FileUploader({url: ''});
    attachmentFile;
    errorMsg;
    _ = _;

    constructor(private rs: RestService,
                private authService: AuthService,
                private translateService: TranslationService,
                private http: HttpClient,
                private ns:NotificationService,
                public gs:GeneralService) { }

    ngOnInit() {
        this.textMessage = '';

        try {
            const OSSelectedType = platform.os.family.replace('Chromium', '').trim();
            if (OSSelectedType === 'OS X') {
                this.OSSelectedType = 'Mac';
            }
            else if (["Ubuntu", "Debian", "Fedora", "Red Hat", "SuSE"].indexOf(OSSelectedType) >= 0) {
                this.OSSelectedType = 'Linux';
            }
        } catch (ex) {
            console.error(ex);
        }

        try {
            if (platform.name.includes('Chrome')) {
                this.browserSelected = 'Chrome';
            } else if (platform.name.includes('Firefox')) {
                this.browserSelected = 'Firefox';
            } else if (platform.name.includes('Safari')) {
                this.browserSelected = 'Safari';
            } else if (platform.name.includes('Edge')) {
                this.browserSelected = 'Edge';
            }
        } catch (ex) {
            console.error(ex);
        }
    }

    sendMessageToSupport = () => {
        if (!this.textMessage || this.createTicketInProcess) return;

        this.createTicketInProcess = true;

        const ticketInfo:any = {
            title: this.messageTitle,
            type: this.reasonSelected,
            message: this.textMessage,
            OS: this.OSSelectedType,
            browser: this.browserSelected
        };

        if (this.attachmentFile) {
            ticketInfo.attachment = this.attachmentFile;
        }

        const formData = new FormData();
        // parameters
        for (const [key, value] of Object.entries(ticketInfo) as any) {
            formData.append(key, value);
        }
        const headers = new HttpHeaders(this.authService.getHeaders());

        const req = new HttpRequest('POST', ENV_CONSTS.beBaseAttachmentUrl + '/user/tickets', formData, {headers});

        this.http.request(req).subscribe({
            next: event => {
                if (event.type === HttpEventType.Response) {
                    this.ns.showInfoMessage(dic.MESSAGES.supportContactUs);
                    this.ns.notificationPriority();
                    this.gs.toggleSupportForm(false); // Close the support component

                    this.textMessage = '';
                    this.messageTitle = '';
                    this.attachmentFile = null;
                    this.reasonSelected = this.reason[0];
                    this.createTicketInProcess = false;
                }
            }, error: err => {
                this.createTicketInProcess = false;
            }
        });
    }

    selectFile(files) {
        if (!files?.length) {
            return;
        }

        this.errorMsg = '';
        const file = files[0];

        if (file.size > 20970000) {
            this.errorMsg = util.format(this.translateService.getTranslationText('ERRORS.fileMaxSizeX'), '20MB');
            return;
        }

        this.attachmentFile = file;
    }
}
